const REQUEST_ID_PATTERN = /^[A-Za-z0-9]{22}$/u;

/** Schemes that `location.assign` runs as script on this origin. */
const SCRIPT_SCHEMES = new Set([ 'javascript:', 'data:', 'vbscript:' ]);

/** The request id from the consent link, or null when it cannot be one. */
export const parseDeviceLoginRequestId = (value: unknown): string | null =>
  typeof value === 'string' && REQUEST_ID_PATTERN.test(value) ? value : null;

/**
 * The redirect from an approval or denial, or null when there is none to follow.
 * Custom schemes pass, because a native app can register one as its callback.
 */
export const safeDeviceLoginRedirect = (url: string | null | undefined): string | null => {
  if (!url) { return null; }
  try {
    return SCRIPT_SCHEMES.has(new URL(url).protocol) ? null : url;
  } catch (e) {
    return null;
  }
};

/** The host the consent screen names for a CONFIDENTIAL app's callback. */
export const deviceLoginCallbackHost = (callbackUrl: string | null | undefined): string | null => {
  if (!callbackUrl) { return null; }
  try {
    const url = new URL(callbackUrl);
    return url.host || url.protocol;
  } catch (e) {
    return null;
  }
};
